import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { DashboardSummary } from '../models/dashboardSummary';
import { Pagination } from '../models/pagination';
import { Project } from '../models/project';
import { TalentDashboardNotification } from '../models/talentDashboardNotification';

const baseUrl = '/dashboard';

const getTalentProjects = (
  config?: AxiosRequestConfig
): Promise<AxiosResponse<Pagination<Project>>> =>
  axios.get(`${baseUrl}/talent/projects`, config);

const getTalentNotifications = (): Promise<
  AxiosResponse<TalentDashboardNotification>
> => axios.get(`${baseUrl}/talent`);

const getDashboardSummary = (): Promise<AxiosRequestConfig<DashboardSummary>> =>
  axios.get<DashboardSummary>(`${baseUrl}/summary`);

export const dashboardService = {
  getTalentProjects,
  getTalentNotifications,
  getDashboardSummary
};
